module.exports = __webpack_public_path__ + "static/media/blog.80fc6cb3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/blog.svg
// module id = 1415
// module chunks = 1